import * as types from "../constants/actionTypes";
import * as tools from "../helpers/Tools";

export const healthsourceInitialState = {
    linkEmployeeFailureMessage: null,
    linkEmployeeSuccessMessage: null,
    linkEmployeeInProcess: false,
    unlinkEmployeeFailureMessage: null,
    unlinkEmployeeSuccessMessage: null,
    unlinkEmployeeInProcess: false,
    linkMyChartFailureMessage: null,
    linkMyChartSuccessMessage: null,
    linkMyChartInProcess: false,
    unlinkMyChartFailureMessage: null,
    unlinkMyChartSuccessMessage: null,
    unlinkMyChartInProcess: false,
    linkHealthPlanFailureMessage: null,
    linkHealthPlanSuccessMessage: null,
    linkHealthPlanInProcess: false,
    unlinkHealthPlanFailureMessage: null,
    unlinkHealthPlanSuccessMessage: null,
    unlinkHealthPlanInProcess: false,
    ProviderDetailNPIList: null,
    favoriteProviders: null,
    favoriteProvidersCards: null,
    fetchingFavoriteProviders: false,
    careTeamProviders: null,
    careTeamProvidersCards: null,
    fetchingCareTeamProviders: false,
    arrayFavoriteNPIs: [],
    arrayCareTeamNPIs: [],
    userAddress: null,
    fetchingLatLong: false,
    fetchingUserAddress: false,
    isFetchingUserAddressToLatLngFailure: false,
    countOfLinkMyChartError: 0,
    autolinkMyChartSuccess:null
};

function trimResultMessage(sMessage) {
    if (sMessage) {
        sMessage = sMessage.replace(/"/g, "");

        //Commenting this code due to corelated issue with other api error message.
        //let iPeriod = sMessage.indexOf(".");
        //if (iPeriod > 0) {
        //    return sMessage.substring(0, iPeriod + 1);
        //}
        //else {
        //    return sMessage;
        //}

        return sMessage;
    }
}


function getErrorMsg(errorMsg) {
    const matchedPhoneNumber = errorMsg && errorMsg.match(/.*(\d{3}\.\d{3}\.\d{4}).*/) && errorMsg.match(/.*(\d{3}\.\d{3}\.\d{4}).*/)[1];    
    if (errorMsg && matchedPhoneNumber) {
        const phoneNumber = `<a href="tel:${matchedPhoneNumber}">${matchedPhoneNumber}</a>`;
        return { __html: `${trimResultMessage(errorMsg.replace(matchedPhoneNumber, phoneNumber))}` };
    } else {
        return {
            __html: `${trimResultMessage(errorMsg)}`
        };
    }
}

export default function healthSourceReducer(state = healthsourceInitialState, action) {   
    switch (action.type) {
        
        case types.LINK_EMPLOYEE_ACCOUNT_START:
            return { ...state, linkEmployeeFailureMessage: null, linkEmployeeSuccessMessage: null, linkEmployeeInProcess: true };

        case types.LINK_EMPLOYEE_ACCOUNT_FAILURE:
            return { ...state, linkEmployeeFailureMessage: getErrorMsg(action.errorText), linkEmployeeSuccessMessage: null, linkEmployeeInProcess: false };

        case types.LINK_EMPLOYEE_CLEAR_MESSAGE:
            return { ...state, linkEmployeeFailureMessage: null, linkEmployeeSuccessMessage: null };

        case types.LINK_EMPLOYEE_ACCOUNT_SUCCESS:
            return { ...state, linkEmployeeFailureMessage: null, linkEmployeeSuccessMessage: trimResultMessage(action.successText), linkEmployeeInProcess: false };


        case types.UNLINK_EMPLOYEE_ACCOUNT_START:
            return { ...state, unlinkEmployeeFailureMessage: null, unlinkEmployeeSuccessMessage: null, unlinkEmployeeInProcess: true };

        case types.UNLINK_EMPLOYEE_ACCOUNT_FAILURE:
            return { ...state, unlinkEmployeeFailureMessage: getErrorMsg(action.errorText), unlinkEmployeeSuccessMessage: null, unlinkEmployeeInProcess: false };

        case types.UNLINK_EMPLOYEE_CLEAR_MESSAGE:
            return { ...state, unlinkEmployeeFailureMessage: null, unlinkEmployeeSuccessMessage: null };

        case types.UNLINK_EMPLOYEE_ACCOUNT_SUCCESS:
            return { ...state, unlinkEmployeeFailureMessage: null, unlinkEmployeeSuccessMessage: trimResultMessage(action.successText), unlinkEmployeeInProcess: false };


        case types.LINK_MYCHART_ACCOUNT_START:
            return { ...state, linkMyChartFailureMessage: null, linkMyChartSuccessMessage: null, linkMyChartInProcess: true };

        case types.LINK_MYCHART_ACCOUNT_FAILURE:
            return { ...state, linkMyChartFailureMessage: getErrorMsg(action.errorText), linkMyChartSuccessMessage: null, linkMyChartInProcess: false };

        case types.LINK_MYCHART_CLEAR_MESSAGE:
            return { ...state, linkMyChartFailureMessage: null, linkMyChartSuccessMessage: null };

        case types.LINK_MYCHART_ACCOUNT_SUCCESS:
            return { ...state, linkMyChartFailureMessage: null, linkMyChartSuccessMessage: trimResultMessage(action.successText), linkMyChartInProcess: false };

        case types.UNLINK_MYCHART_ACCOUNT_START:
            return { ...state, unlinkMyChartFailureMessage: null, unlinkMyChartSuccessMessage: null, unlinkMyChartInProcess: true };

        case types.UNLINK_MYCHART_ACCOUNT_FAILURE:
            return { ...state, unlinkMyChartFailureMessage: getErrorMsg(action.errorText), unlinkMyChartSuccessMessage: null, unlinkMyChartInProcess: false };

        case types.UNLINK_MYCHART_CLEAR_MESSAGE:
            return { ...state, unlinkMyChartFailureMessage: null, unlinkMyChartSuccessMessage: null };

        case types.UNLINK_MYCHART_ACCOUNT_SUCCESS:
            return { ...state, unlinkMyChartFailureMessage: null, unlinkMyChartSuccessMessage: trimResultMessage(action.successText), unlinkMyChartInProcess: false };

        case types.LOAD_MYCHART_TERMS_DATA_START:
            return { ...state, myChartTermsFailureMessage: null, myChartTermsSuccessMessage: null, myChartTermsInProcess: true };

        case types.LOAD_MYCHART_TERMS_DATA_FAILURE:
            return { ...state, myChartTermsFailureMessage: action.errorText, myChartTermsSuccessMessage: null, myChartTermsInProcess: false };

        case types.LOAD_MYCHART_TERMS_DATA_SUCCESS:
            return { ...state, myChartTermsFailureMessage: null, myChartTermsSuccessMessage: action.successText, myChartTermsInProcess: false };

        case types.LOAD_HEALTHSOURCEDASHBOARD_START:
            return { ...state, error: false, isFetching: true };
        case types.LOAD_HEALTHSOURCEDASHBOARD_SUCCESS:
            var oNewData = [];
            action.healthSourceDashboardData.forEach(function (old, index) {
                oNewData.push({
                    Name: old.Name,
                    ActionLink: old.ActionLink,
                    ImageURL: old.ImageURL,
                    FeatureName: old.FeatureName,
                    Title: old.Title,
                    TileId: old.TileId,
                    Tags: old.Tags 
                });
            });
            return { ...state, isFetching: action.isWaiting, healthSourceDashboardDetails: oNewData };
        case types.AJAX_CALL_ERROR:
            return { ...state, isFetching: false, healthSourceError: action.healthSourceError };
        case types.USER_LOGGED_OUT:
            return { ...healthsourceInitialState, error: action.errorCode };

        case types.GET_FAVORITE_PROVIDERS_START:
            return { ...state, fetchingFavoriteProviders: true };
        case types.GET_FAVORITE_PROVIDERS_SUCCESS:
            return { ...state, fetchingFavoriteProviders: false, fetchingCareTeamProviders: false };
        case types.GET_FAVORITE_PROVIDERS_FAILURE:
            return { ...state, fetchingFavoriteProviders: false, fetchingCareTeamProviders: false };

        //case types.GET_CARETEAM_PROVIDERS_START:
        //    return { ...state, fetchingCareTeamProviders: true };
        //case types.GET_CARETEAM_PROVIDERS_SUCCESS:
        //    //debugger;
        //    oDisplayList = tools.splitIntoRowsOf(action.providerList, 2);
        //    return { ...state, careTeamProviders: action.providerList, careTeamProvidersCards: oDisplayList, fetchingCareTeamProviders: false };
        //case types.GET_CARETEAM_PROVIDERS_FAILURE:
        //    return { ...state, careTeamProviders: null, careTeamProvidersCards: null, fetchingCareTeamProviders: false };


        case types.ADD_FAVORITE_PROVIDER_SUCCESS:
            //let oAddedList = state.favoriteProviders;
            //action.newFavorite.forEach((old, index) => {
            //    oAddedList.push(old);
            //});
            return {
                ...state,
                //favoriteProviders: oAddedList,
                //favoriteProvidersCards: tools.splitIntoRowsOf(oAddedList, 2),
                fetchingFavoriteProviders: false
            };

        case types.REMOVE_FAVORITE_PROVIDER_SUCCESS:
            // Just reduce out the removed provider rather than refetch
            //let oCurrentList = state.favoriteProviders;
            //let oNewList = [];
            //oCurrentList.forEach(function (old, index) {
            //    if (old.NPI !== action.npi) {
            //        oNewList.push(old);
            //    }
            //});
            return {
                ...state,
                //favoriteProviders: oNewList,
                //favoriteProvidersCards: tools.splitIntoRowsOf(oNewList, 2),
                fetchingFavoriteProviders: false
            };

        case types.SET_PROVIDER_DETAILS_NPI_LISTS:
            return { ...state, arrayFavoriteNPIs: action.arrayFavoriteNPIs, arrayCareTeamNPIs: action.arrayCareTeamNPIs };

        case types.SET_PARSED_PROVIDER_DETAILS_LISTS:
            let sorted = action.arrayFavorites && action.arrayFavorites.length > 0 ?
                action.arrayFavorites.sort((a, b) => a.lastName < b.lastName ? -1 : 0) :
                [];
            return {
                ...state,
                favoriteProvidersCards: tools.splitIntoRowsOf(sorted, 2), // we only need the reduced copies now (since we have the master ProviderDetailList and NPI string arrays)
                careTeamProvidersCards: tools.splitIntoRowsOf(action.arrayCareTeam, 2)
            };

        case types.GET_USER_ADDRESS_START:
            return { ...state, fetchingUserAddress: true };
        case types.GET_USER_ADDRESS_SUCCESS:
            return { ...state, userAddress: action.getUserAddressResponse, fetchingUserAddress: false };
        case types.GET_USER_ADDRESS_FAILURE:
            return { ...state, userAddress: null, fetchingUserAddress: false };
        case types.GET_LAT_LNG_USER_ADDRESS_START:
            return { ...state, fetchingLatLong: true, isFetchingUserAddressToLatLngFailure: false };
        case types.GET_LAT_LNG_USER_ADDRESS_SUCCESS:
            return { ...state, userLocation: { lat: action.getLatLongResponse && action.getLatLongResponse.lat ? action.getLatLongResponse.lat : null, lng: action.getLatLongResponse && action.getLatLongResponse.lng ? action.getLatLongResponse.lng : null }, fetchingLatLong: false, isFetchingUserAddressToLatLngFailure: false };
        case types.GET_LAT_LNG_USER_ADDRESS_FAILURE:
            return {
                ...state, userLocation: null, fetchingLatLong: false, isFetchingUserAddressToLatLngFailure: true
            };  
        case types.AUTOLINK_MYCHART:
            return { ...state, isAutoLinkMyChartWaiting: true};
        case types.AUTOLINK_MYCHART_FAILURE:
            return { ...state, autolinkMyChartSuccess: null, isAutoLinkMyChartWaiting: false, autolinkMyChartFailure: action.autolinkMyChartFailure };
        case types.AUTOLINK_MYCHART_SUCCESS:
            return { ...state, autolinkMyChartSuccess: action.autolinkMyChartSuccess, isAutoLinkMyChartWaiting: false };
        case types.AUTOLINK_MYCHART_ERROR_COUNT:            
            return { ...state, countOfLinkMyChartError: action.payload ? action.payload.countOfLinkMyChartError : state.countOfLinkMyChartError + 1 };
        case types.AUTOLINK_MYCHART_CLEAR_MESSAGE:
            return { ...state, autolinkMyChartSuccess: null, autolinkMyChartFailure: null };
        default:
            return { ...state };

    }
}